import { useFeatureFlagEnabled } from "posthog-js/react";
import MeasureInput from "./GenericMeasureInputs";

interface MeasureOverrideProps {
    measure: CarbonReductionMeasure | null;
    measureInputs: CarbonReductionMeasureInput;
    setMeasure: (measure: CarbonReductionMeasureInput) => void;
}

function MeasureOverrides({ measure, measureInputs, setMeasure }: MeasureOverrideProps) {
    const projectCustomLandlordSharesEnabled = useFeatureFlagEnabled("building-custom-plan-landlord-shares-input");

    return (
        <div>
            <MeasureInput
                label="Project total cost"
                value={measureInputs.measureCost}
                onChange={(value) => setMeasure({ ...measureInputs, measureCost: value })}
                placeholder={`${measure?.measureCost || "Enter total measure cost (optional)"}`}
            />
            <MeasureInput
                label="Like for like cost"
                value={measureInputs.likeForLikeCost}
                onChange={(value) => setMeasure({ ...measureInputs, likeForLikeCost: value })}
                placeholder={`${measure ? measure.likeForLikeCost : "Enter like for like cost (optional)"}`}
            />
            <MeasureInput
                label="Project size"
                value={measureInputs.measureSize}
                onChange={(value) => setMeasure({ ...measureInputs, measureSize: value })}
                placeholder={`${measure ? measure.measureSize : "Enter size (optional)"}`}
            />
            <MeasureInput
                label="Project incentives"
                value={measureInputs.totalIncentives}
                onChange={(value) =>
                    setMeasure({
                        ...measureInputs,
                        totalIncentives: value,
                    })
                }
                placeholder={`${measure ? measure.totalIncentives : "Enter total incentives (optional)"}`}
            />
            {projectCustomLandlordSharesEnabled && (
                <>
                    <MeasureInput
                        label="Landlord share of cost"
                        value={measureInputs.landlordShareCost}
                        onChange={(value) =>
                            setMeasure({
                                ...measureInputs,
                                landlordShareCost: value,
                            })
                        }
                        placeholder={`${measure ? measure.landlordShareCost : "Enter landlord share of cost (optional)"}`}
                    />
                    <MeasureInput
                        label="Landlord share of electricity"
                        value={measureInputs.landlordShareElectricity}
                        onChange={(value) =>
                            setMeasure({
                                ...measureInputs,
                                landlordShareElectricity: value,
                            })
                        }
                        placeholder={`${measure ? measure.landlordShareElectricity : "Enter landlord share of electricity utility (optional)"}`}
                    />
                    <MeasureInput
                        label="Landlord share of natural gas"
                        value={measureInputs.landlordShareNaturalGas}
                        onChange={(value) =>
                            setMeasure({
                                ...measureInputs,
                                landlordShareNaturalGas: value,
                            })
                        }
                        placeholder={`${measure ? measure.landlordShareNaturalGas : "Enter landlord share of natural gas utility (optional)"}`}
                    />
                </>
            )}
        </div>
    );
}

export default MeasureOverrides;
